export default __webpack_public_path__ + "static/media/2.c2cc4911.png";